const TICKET_CODES = {
  ticket_missing: true,
  ticket_invalid: true,
  ticket_expired: true,
  ticket_replayed: true,
};

export function isAntifraudEnabled() {
  if (typeof process !== "undefined" && process.env && process.env.REACT_APP_ANTIFRAUD_ENABLED === "false") {
    return false;
  }
  return true;
}

export function errorCode(error) {
  return error?.response?.data?.code || error?.code || null;
}

export function ticketErrorCode(error) {
  const code = errorCode(error);
  return TICKET_CODES[code] ? code : null;
}

export async function fetchChallenge(challengeUrl, { renew, escalate } = {}) {
  const body = {};
  if (renew) {
    body.renew = renew;
  }
  if (escalate) {
    body.escalate = true;
  }
  const response = await fetch(challengeUrl, {
    method: "POST",
    // No cookies needed for a ticket; "include" breaks cross-origin dev setups.
    credentials: "same-origin",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    return { ticket: null };
  }
  try {
    return await response.json();
  } catch (_error) {
    return { ticket: null };
  }
}

export async function withTicketRetry(submit, ticketApi) {
  try {
    return await submit(await ticketApi.getEnvelope());
  } catch (error) {
    const code = errorCode(error);
    if (code === "risk_denied") {
      throw error;
    }
    if (TICKET_CODES[code]) {
      await ticketApi.renew();
      return submit(await ticketApi.getEnvelope());
    }
    if (code === "challenge_required" || code === "puzzle_exhausted") {
      await ticketApi.renew({ escalate: true });
      return submitWithPuzzle(submit, ticketApi);
    }
    if (code === "puzzle_miss") {
      return submitWithPuzzle(submit, ticketApi, { needNewAnswer: true });
    }
    throw error;
  }
}

// The server allows 3 attempts per puzzle; a miss must wait for a new answer
// instead of resending the old one.
const PUZZLE_ATTEMPTS = 3;

async function submitWithPuzzle(submit, ticketApi, { needNewAnswer = false } = {}) {
  let fresh = needNewAnswer;
  for (let attempt = 1; ; attempt += 1) {
    if (ticketApi.waitPuzzleIfNeeded) {
      if (fresh && ticketApi.clearPuzzleAnswer) {
        ticketApi.clearPuzzleAnswer();
      }
      await ticketApi.waitPuzzleIfNeeded();
    }
    try {
      return await submit(await ticketApi.getEnvelope());
    } catch (error) {
      if (errorCode(error) !== "puzzle_miss" || attempt >= PUZZLE_ATTEMPTS) {
        throw error;
      }
      fresh = true;
    }
  }
}
